export default function Footer({ isDarkMode }) {
  return (
    <footer
      className={`px-6 py-3 text-xs ${
        isDarkMode
          ? 'bg-gray-800 border-gray-700 text-gray-400'
          : 'text-gray-500'
      } hidden md:block`}
    >
      <div className="flex justify-center items-center">
        <div className="text-center max-w-4xl">
          uLegal.ai provides AI-powered legal information, not legal advice. Our
          services do not establish an attorney-client relationship.Content is
          informational only and not a substitute for consulting a licensed
          attorney.You retain responsibility for uploaded documents. By using
          uLegal.ai, you accept our{' '}
          <a
            href="https://www.ulegal.ai/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-300"
          >
            Terms
          </a>{' '}
          &{' '}
          <a
            href="https://www.ulegal.ai/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-300"
          >
            Privacy
          </a>
          .
        </div>
      </div>
    </footer>
  );
}
